// ══════════════════════════════════════════════════════════════
// Portal del agente — fotos más ligeras para el PDF Premium (B-BLOQUE-09).
// react-pdf incrusta cada JPEG tal cual: 5 fotos de 2 MB = PDF de ~10 MB. Aquí se reducen en el
// navegador (canvas) al tamaño que de verdad se imprime antes de generar el PDF.
//   · Portada (fotos[0]): 540 pt de ancho → 1400 px basta y sobra.
//   · Galería (fotos[1..4]): miniaturas de ~130 pt → 600 px.
// Si algo falla (CORS, formato raro, sin canvas) se devuelve la URL original: el PDF sale igual, solo más pesado.
// ══════════════════════════════════════════════════════════════

const ANCHO_PORTADA = 1400;
const ANCHO_GALERIA = 600;
const CALIDAD = 0.82;

export const reducirFoto = async (url, maxAncho, calidad = CALIDAD) => {
  if (typeof document === 'undefined' || typeof createImageBitmap !== 'function') return url;
  try {
    const r = await fetch(url, { mode: 'cors' });
    if (!r.ok) return url;
    const blob = await r.blob();
    const bmp = await createImageBitmap(blob);
    const escala = Math.min(1, maxAncho / bmp.width);
    // Ya es chica y ligera: no se toca (re-comprimir solo le quitaría calidad).
    if (escala === 1 && blob.size <= 350 * 1024) { if (bmp.close) bmp.close(); return url; }
    const w = Math.max(1, Math.round(bmp.width * escala));
    const h = Math.max(1, Math.round(bmp.height * escala));
    const cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    const ctx = cv.getContext('2d');
    ctx.fillStyle = '#FFFFFF';            // PNG con transparencia → fondo blanco (JPEG no tiene alfa)
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(bmp, 0, 0, w, h);
    if (bmp.close) bmp.close();
    const dataUrl = cv.toDataURL('image/jpeg', calidad);
    return dataUrl && dataUrl.startsWith('data:image/jpeg') ? dataUrl : url;
  } catch (e) {
    return url;
  }
};

// [{orden, url, ...}] → mismas filas con `url` reducida. La de menor `orden` es la portada.
export const prepararFotosPdf = async (imagenes) => {
  const lista = (Array.isArray(imagenes) ? imagenes : [])
    .filter(im => im && typeof im.url === 'string' && im.url.trim())
    .slice()
    .sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0))
    .slice(0, 5);
  return Promise.all(lista.map(async (im, i) => ({
    ...im,
    url: await reducirFoto(im.url.trim(), i === 0 ? ANCHO_PORTADA : ANCHO_GALERIA),
  })));
};
